import React, { useState, useEffect } from 'react';
import { Col } from 'react-bootstrap';

import { AlertHighlighter } from './AlertHighlighter';

const NoticeHighlighter = (props) => {
  const [close, setClose] = useState(false);
  const [isMounted, setIsMounted] = useState(true);
  const { nombre_comercial = '', notice = '', variant = 'primary' } = props;

  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, [close]);

  const handleOnClose = async () => {
    setClose(true);

    if (props.isClose()) {
      props.isClose();
    }
  };

  return (
    <>
      {isMounted && (
        <AlertHighlighter
          variant={variant}
          onClose={props.close ? handleOnClose : undefined}
        >
          <Col>
            <strong>{nombre_comercial}</strong> {notice}
          </Col>
        </AlertHighlighter>
      )}
    </>
  );
};

export default NoticeHighlighter;
